<template>
  <div class="listContent">
    <el-row>
      <el-col
        :xs="{ span: 24, offset: 0 }"
        :sm="{ span: 24, offset: 0 }"
        :md="{ span: 22, offset: 1 }"
        :lg="{ span: 22, offset: 1 }"
        :xl="{ span: 20, offset: 2 }"
      >
        <div class="title">
          <el-breadcrumb
            itemscope
            itemtype="https://schema.org/BreadcrumbList"
            separator-class="el-icon-arrow-right"
            class="breadcrumb"
          >
            <el-breadcrumb-item
              itemprop="itemListElement"
              itemscope
              itemtype="https://schema.org/ListItem"
              :to="{ path: '/' }"
              >Home</el-breadcrumb-item
            >
            <el-breadcrumb-item
              itemprop="itemListElement"
              itemscope
              itemtype="https://schema.org/ListItem"
              >{{ categoryName }}</el-breadcrumb-item
            >
          </el-breadcrumb>
        </div>

        <div v-if="categoryDetail" class="descriptions">
          <h1>
            {{ breadcrumb[breadcrumb.length - 1].name }}
          </h1>
          <p v-for="(item, index) in categoryDetail.descriptions" :key="index">
            {{ item }}
          </p>
        </div>

        <div>
          <MouldExhibition
            :moulds="listOfCategories"
            :type="type"
            :disabled="true"
            :loose="true"
            :is-logo="true"
          />
        </div>

        <div v-if="categoryDetail && categoryDetail.qas" class="qa">
          <h2 class="title">FAQ:</h2>
          <template v-for="(item, index) in categoryDetail.qas">
            <div :key="index">
              <h2>
                {{ item.q }}
              </h2>
              <p>
                {{ item.a }}
              </p>
            </div>
          </template>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import MouldExhibition from "@/components/ProductsItem/MouldExhibition";
import categoryDetails from "./categoryDetails";
import suppliers from "./suppliersData";
export default {
  name: "ProductsList",
  components: {
    MouldExhibition,
  },
  data() {
    return {
      searchKey: "",
      selectType: 0,
      type: "",
      name: "",
      categoryId: "",
      propsOption: {
        value: "id",
        label: "name",
        children: "internationalProductsCategoryList",
        expandTrigger: "hover",
        checkStrictly: true,
      },
      // categoryOptions: [],
      listLoad: false,
      breadcrumb: [{ name: "Home", path: "/" }],
    };
  },
  computed: {
    isMobile() {
      return this.$store.state.isMobile;
    },
    categoryName() {
      return this.$route.params.supplier
        .split("-")
        .map((item) => item.replace(/^[a-z]/g, (L) => L.toUpperCase()))
        .join(" ");
    },
    categoryDetail() {
      return categoryDetails[this.$route.params.id] || null;
    },
    listOfCategories() {
      return suppliers[this.$route.params.supplier];
    },
  },
  beforeRouteUpdate(to, from, next) {
    next();
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.listContent {
  background-color: #f2f3f7;
  padding-bottom: 50px;
}

.title {
  text-align: left;
  padding-bottom: 0;

  .breadcrumb {
    line-height: 30px;
    padding-top: 20px;
  }
}

.pagination {
  padding: 20px 0;
}

.nomore {
  font-size: 20px;
  color: #999;
}

.descriptions {
  text-align: left;
  h1 {
    font-size: 2rem;
  }
}

.qa {
  text-align: left;
  h2 {
    margin: 0;
    padding: 0;
  }
  p {
    margin: 0;
    padding: 0.5rem 0 1.5rem;
  }

  .title {
    font-size: 2rem;
    margin-bottom: 1rem;
  }
}
</style>
